<template>
  <div>
    <van-sticky>
        <van-nav-bar
            :title="$t('wuliu.orderSearch')"
            :left-text="$t('indexdata.Return')"
            right-text=""
            left-arrow
            @click-left="onClickLeft"
        />
    </van-sticky>
    <div class="logistics">
        <div>
        <p>{{$t('wuliu.provide')}}：</p>
    </div>
    <div>
        <span>{{$t('wuliu.OrderOrLogistics')}}</span>
    </div>
    <!-- <div style="padding:10px 0">
      <input type="text" v-model="orderNumbe11r" placeholder="通过手机号码查询订单号" style="width:80%">
      <van-button size="small"  @click="iphoneInquiry" type="danger">立即查询</van-button>
    </div> -->
    <div style="padding:10px 0" class="aaaaa">
      <input type="text" v-model.trim="orderNumber" :placeholder="$t('wuliu.orderPlaceho')" style="width:57%">
      <van-button size="small"  @click="orderInquiry" type="danger">{{$t('wuliu.query')}}</van-button>
      <!-- <van-button size="small"  @click="iphoneInquiry" type="danger">查询手机号</van-button> -->
    </div>
    <div class="contentList">
        <div v-for="(item,index) in content" :key="index" style="padding:5px">
            <p>{{item.content}}</p><span>{{item.time}}</span>
        </div>
    </div>
    <div >
        <p style="color:red"> {{errContent}}</p>
    </div>
   
    <div class="tishi">
        <b>{{$t('wuliu.Tips')}}:</b><span>{{$t('wuliu.Tipsinfo')}}</span>
    </div>
    </div>
  </div>
</template>

<script>
  import PicZoom from "vue-piczoom"
  import goods from '@/api/goods';
    export default {
        name: "FooterShow",
        data(){
            return{
                orderNumber:'',
                errContent:'',
                content:'',
            }
         },
        components:{
          PicZoom
        },
      methods:{
       onClickLeft(){
           this.$router.back()
       },
       orderInquiry(){
           if(!this.orderNumber){
               this.errContent ='Logistics information not found!'
               return false
           }
           this.content= ''
           this.errContent= ''
           let params = {
               track:this.orderNumber,
               region:sessionStorage.getItem('REG') || '',
           }
           goods.getGoodInfo(params).then((res) => {
            //    debugger
               if(res.length>0){
                    this.content = res
               }else{
                   this.errContent ='Logistics information not found!'
               }
            //    if(Array.isArray(res)){
                  
            //        this.errContent = ''
            //    }else{
            //        this.content = ''
            //        this.errContent = res.data
            //    }
           })
       },
       iphoneInquiry(){

       }
      }

    }
</script>

<style scoped='scoped'>
@media screen and (max-width: 768px) {
    .logistics{
        padding: 20px;
        line-height: 30px;
    }
    .contentList{
        word-break:break-all;
        line-height: 18px;
        font-size: 12px;
        border-radius: 5px;
        background: #eee;
    }
    .tishi{
        line-height: 30px;
        margin-top: 20px;
        padding: 5px;
        background: #eee;
    }
}
@media screen and (min-width:768px) and (max-width:970px){
  .logistics{
        padding: 40px;
        line-height: 35px;
    }
    .contentList{
        word-break:break-all;
        line-height: 18px;
        font-size: 12px;
        border-radius: 5px;
        background: #eee;
    }
    .tishi{
        line-height: 35px;
        margin-top: 20px;
        padding: 5px;
        background: #eee;
    }
}
@media screen and (min-width: 970px) {
    .logistics{
        padding: 40px;
        line-height: 30px;
    }
    .contentList{
        word-break:break-all;
        line-height: 30px;
        font-size: 12px;
        border-radius: 5px;
        background: #eee;
    }
    .tishi{
        line-height: 35px;
        margin-top: 20px;
        padding: 5px;
        background: #eee;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/logistics/logistics.vue